import {Input} from '@angular/core';

/**
 * Created by Boris on 15/02/2017.
 */
export class PaymentData {
  sessionAlreadyExists: boolean;
  sessionId: string;
  sst: string;
  isPaymentDone: boolean;

  TermsConditionsData() {
    this.sessionAlreadyExists = false;
    this.sessionId = '';
    this.sst = '';
    this.isPaymentDone = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/payment-data.ts